import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const UNAUTHENTICATED_LANDING_CLASS_NAME = 'UnauthenticatedLanding';
export const UNAUTHENTICATED_LANDING_CLASS_SLOTS = [
	'root',
	'content',
	'tabPanel',
] as const;

export type UnauthenticatedLandingClassSlot =
	typeof UNAUTHENTICATED_LANDING_CLASS_SLOTS[number];

export interface UnauthenticatedLandingClasses {
	root: string;
	content: string;
	tabPanel: string;
}

export type UnauthenticatedLandingClassKey =
	keyof UnauthenticatedLandingClasses;

export const getUnauthenticatedLandingUtilityClass = (slot: string) =>
	generateUtilityClass(UNAUTHENTICATED_LANDING_CLASS_NAME, slot);

export const unauthenticatedLandingClasses = generateUtilityClasses<
	keyof UnauthenticatedLandingClasses
>(UNAUTHENTICATED_LANDING_CLASS_NAME, ['root', 'content', 'tabPanel']);
export default unauthenticatedLandingClasses;
